{
  "intro_welcome_header": "Welcome to the home of Amax Emu!",
  "intro_welcome_description": "Blur is a pretty decent game.",
  "sessions_widget_header": "Active sessions",
  "sessions_widget": {
    "status": {
      "inprogress": "In progress",
      "inlobby": "In lobby"
    },
    "gamemode": {
      "skirmish": "Skirmish racing",
      "drivingschool": "Driving school",
      "powered_up_racing": "Powered-up racing",
      "teamracing": "Team racing",
      "hardcore_racing": "Hardcore racing",
      "team_motor_mash": "Team Motor Mash",
      "motormash": "Motor Mash",
      "communityevent": "Community events",
      "worldtour": "World tour"
    }
  },
  "profile_stats": {
    "stats": "Stats",
    "pastraces": "Past Races",
    "career": "Career",
    "combat": "Combat",
    "racing": "Racing"
  },
  "leaderboard_widget": {
    "header": "Top 10",
    "position": "Pos.",
    "player": "Player",
    "fans": "Fans",
    "driving_score": "Driving score",
    "legend": "Legend",
    "value": "Value"
  },
  "general_values_names": {
    "fans": "Fans",
    "level": "Fans",
    "driving_score": "Driving score",
    "legend": "Legend",
    "total_race": "Total races",
    "top3": "Top 3",
    "first": "First",
    "hits": "Hits",
    "fired": "Fired",
    "total_time": "Total race time",
    "wrecked": "Wrecks"
  },
  "server_status_widget": {
    "server_status": "Server status",
    "offline": "Offline",
    "online": "Online",
    "players": "Players online:",
    "sessions": "Sessions:"
  },
  "appbar": {
    "login_discord": "Login with Discord",
    "create_amax_account": "Create Amax Emu account",
    "profile": "Profile"
  },
  "how_to_play": {
    "header": "How to play Blur online",
    "login_step_header": "Login with your Discord account",
    "login_step_text": "Login with your Discord account using the button below",
    "create_amax_account_header": "Create Amax Emu account",
    "create_amax_account_text": "Create Amax emu (in game) account using the button below.",
    "blur_download_step_header": "Get a copy of Blur",
    "blur_download_step_text": "Install Blur from your legally owned DVD from 2010 or download it from your Steam library.",
    "patch_step_header": "Install patch 1.2",
    "patch_step_text1": "You can download patch 1.2 files from here. ",
    "patch_step_text2": "You don't need to do it if you installed game thought Steam",
    "patch_step_text3": "Place patch files to the root of your Blur installation",
    "amax_emu_step_header": "Add Amax Emu files",
    "amax_emu_step_text": "Download latest Amax Emu files from here and place them into root of your Blur installation.",
    "amax_emu_login_step_header": "Login into the Amax Emu in the game",
    "amax_emu_login_step_text": "Login into the Amax Emu using your username and password.",
    "play_step_header": "Play Blur",
    "play_step_text": "Enjoy Blur like it is 2010 again!"
  }
}